export default __webpack_public_path__ + "static/media/card4-edp.53138918.png";